export default {

  methods: {
    
    draw_Timeline() {    

      let st = this.timeline.styles
      let type = this.timeline.type

      let Timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(${0}, ${this.chart.height + .5})`)
      .style('font-family', 'roboto')

      // Week -----------------------------------------------------------------------
      if(type == 'week') {
        Timeline
        .append('line')
        .attr('x1', this.chart.width).attr('y1', 0)
        .attr('x2', this.chart.width).attr('y2', st.week.lineY)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        Timeline
        .selectAll('line1')
        .data(this.timeline.week)
        .enter()
        .append('line')
        .attr('x1', d => d.sx).attr('y1', 0)
        .attr('x2', d => d.sx).attr('y2', st.week.lineY)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        Timeline
        .selectAll('text1')
        .data(this.timeline.week)
        .enter()
        .append('text')
        .attr('x', d=> d.mx).attr('y', st.week.textY + st.week.tSize*0.36)
        .attr('font-size', st.week.tSize).attr('fill', st.week.tColor)
        .attr('text-anchor', 'middle')
        .text(d => d.name)
      }


      // Month -----------------------------------------------------------------------
      Timeline
      .append('line')
      .attr('x1', this.chart.width).attr('y1', (type == 'month') ? 0 : st.week.lineY)
      .attr('x2', this.chart.width).attr('y2', st.month.lineY)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('line2')
      .data(this.timeline.month)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', (type == 'month') ? 0 : st.week.lineY)
      .attr('x2', d => d.sx).attr('y2', st.month.lineY)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('text2')
      .data(this.timeline.month)
      .enter()
      .append('text')
      .attr('x', d=> d.mx).attr('y', st.month.textY + st.month.tSize*0.36)
      .attr('font-size', st.month.tSize).attr('fill', st.month.tColor)
      .attr('text-anchor', 'middle')
      .text(d => d.name)


      // Year -----------------------------------------------------------------------
      Timeline
      .append('line')
      .attr('x1', this.chart.width).attr('y1', st.month.lineY)
      .attr('x2', this.chart.width).attr('y2', st.year.lineY)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('line3')
      .data(this.timeline.year)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', st.month.lineY)
      .attr('x2', d => d.sx).attr('y2', st.year.lineY)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('text3')
      .data(this.timeline.year)
      .enter()
      .append('text')
      .attr('x', d=> d.mx).attr('y', st.year.textY + st.year.tSize*0.36)
      .attr('font-size', st.year.tSize).attr('fill', st.year.tColor)
      .attr('text-anchor', 'middle')
      .text(d => d.name)

    },

  }
}
